module.exports = __webpack_public_path__ + "img/sc.cce51329.svg";